export const GET_TEACHER_CHAT_LIST = "GET_TEACHER_CHAT_LIST";
export const GET_TEACHER_SINGLE_CHAT_VIEW = "GET_TEACHER_SINGLE_CHAT_VIEW";
export const SEND_TEACHER_CHAT = "SEND_TEACHER_CHAT";
